<template>
  <div>
    <notification-component v-if="enable_notifications"></notification-component>
    <notifications group="custom-template">
      <template v-slot:body="props">
        <NotificationPopup :item="props.item" @close="props.close"></NotificationPopup>
      </template>
    </notifications>

    <ReportModal></ReportModal>
    <PaymentModal></PaymentModal>
    <BuyProfileModal></BuyProfileModal>
    <BuyMediaModal></BuyMediaModal>
    <PushNotificationModal v-if="user && enable_push_notifications"></PushNotificationModal>
    <BirthdateChangeModal v-if="user"></BirthdateChangeModal>
    <!--<Guide v-if="user && enable_guide"></Guide>-->
    <EventPopupComponent v-if="enable_event_popup"></EventPopupComponent>
    <PreferencesModal v-if="enable_preferences_modal"></PreferencesModal>

    <UserTrackingComponent v-if="user" :user-id="user.id"></UserTrackingComponent>
  </div>
</template>
<script>
import ReportModal from '../modules/ReportModal';
import PaymentModal from '../modules/PaymentModal';
import NotificationPopup from './Notification/NotificationPopup';
import BuyProfileModal from '../modules/BuyProfileModal';
import BuyMediaModal from '../modules/BuyMediaModal';
import PushNotificationModal from '../modules/PushNotificationModal';
import BirthdateChangeModal from '../modules/BirthdateChangeModal.vue';
import { mapGetters } from 'vuex';
// import Guide from '../modules/Guide';
import EventPopupComponent from '../../front/components/Notification/EventPopupComponent';
import PreferencesModal from '../../front/components/User/PreferencesModal.vue';
import UserTrackingComponent from '../../front/components/User/UserTrackingIDComponent';

export default {
  name: 'GlobalComponent',
  components: {
    UserTrackingComponent,
    PreferencesModal,
    PushNotificationModal,
    BuyMediaModal,
    BuyProfileModal,
    NotificationPopup,
    PaymentModal,
    ReportModal,
    EventPopupComponent,
    BirthdateChangeModal: BirthdateChangeModal
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      userPrefFlag: 'getPrefFlag',
    }),
    ...mapGetters('settings', {
      enable_notifications: 'getEnableNotifications',
      enable_push_notifications: 'getEnablePushNotifications',
      enable_guide: 'getEnableGuide',
      enable_event_popup: 'getEnableEventPopup',
      enable_cookie_consent: 'getEnableCookieConsent',
      enable_preferences_modal: 'getEnablePreferencesModal',
    }),
  },
  watch: {},
  methods: {
    hideCookieDialogs: function () {
      document.body.classList.add('hide-cookie-dialogs');

      const cookies = document.querySelector('.js-cookie-consent .js-cookie-consent-agree');
      if (cookies) {
        cookies.click();
      }

      const cookiebotButton = document.getElementById('CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll');
      if (cookiebotButton) {
        cookiebotButton.click();
      }
    },
  },
  mounted() {
    if (['/terms', '/agb', '/privacy', '/faq'].includes(this.$route.path)) {
      this.$store.commit('settings/setDisablePopups');
    }

    if (!this.enable_cookie_consent || this.$route.query.link_source === 'webview') {
      this.hideCookieDialogs();

      setTimeout(() => {
        this.hideCookieDialogs();
      }, 100);
    }

    setTimeout(() => {
      if (this.user && this.user.filled_at && this.userPrefFlag !== true) {
        this.$eventHub.$emit('PreferencesModalOpen');
      }
    }, 5000);

  }
};
</script>
